/**
 * This file was automatically generated by @cosmwasm/ts-codegen@0.24.0.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run the @cosmwasm/ts-codegen generate command to regenerate this file.
 */

export interface InstantiateMsg {
  minter: string;
  name: string;
  royalty_payment_address?: string | null;
  royalty_percentage?: number | null;
  symbol: string;
}
export type ExecuteMsg =
  | {
      send_from: {
        from: string;
        msg?: Binary | null;
        to: string;
        token_id: string;
        value: Uint128;
      };
    }
  | {
      batch_send_from: {
        batch: [string, Uint128][];
        from: string;
        msg?: Binary | null;
        to: string;
      };
    }
  | {
      mint: {
        msg?: Binary | null;
        royalty_payment_address?: string | null;
        royalty_percentage?: number | null;
        to: string;
        token_id?: string | null;
        value: Uint128;
      };
    }
  | {
      batch_mint: {
        batch: [string, Uint128][];
        msg?: Binary | null;
        to: string;
      };
    }
  | {
      burn: {
        from: string;
        token_id: string;
        value: Uint128;
      };
    }
  | {
      batch_burn: {
        batch: [string, Uint128][];
        from: string;
      };
    }
  | {
      approve_all: {
        expires?: Expiration | null;
        operator: string;
      };
    }
  | {
      revoke_all: {
        operator: string;
      };
    };
export type Binary = string;
export type Uint128 = string;
export type Expiration =
  | {
      at_height: number;
    }
  | {
      at_time: Timestamp;
    }
  | {
      never: {};
    };
export type Timestamp = Uint64;
export type Uint64 = string;
export type QueryMsg =
  | {
      royalty_info: {
        sale_price: Uint128;
        token_id: string;
      };
    }
  | {
      check_royalties: {};
    }
  | {
      contract_info: {};
    }
  | {
      balance: {
        owner: string;
        token_id: string;
      };
    }
  | {
      batch_balance: {
        owner: string;
        token_ids: string[];
      };
    }
  | {
      approved_for_all: {
        include_expired?: boolean | null;
        limit?: number | null;
        owner: string;
        start_after?: string | null;
      };
    }
  | {
      is_approved_for_all: {
        operator: string;
        owner: string;
      };
    }
  | {
      token_info: {
        token_id: string;
      };
    }
  | {
      tokens: {
        limit?: number | null;
        owner: string;
        start_after?: string | null;
      };
    }
  | {
      all_tokens: {
        limit?: number | null;
        start_after?: string | null;
      };
    };
export interface TokensResponse {
  tokens: string[];
}
export interface ApprovedForAllResponse {
  operators: Approval[];
}
export interface Approval {
  expires: Expiration;
  spender: string;
}
export interface BalanceResponse {
  balance: Uint128;
}
export interface BatchBalanceResponse {
  balances: Uint128[];
}
export interface CheckRoyaltiesResponse {
  royalty_payments: boolean;
}
export interface ContractInfoResponse {
  name: string;
  symbol: string;
}
export interface IsApprovedForAllResponse {
  approved: boolean;
}
export interface RoyaltiesInfoResponse {
  address: string;
  royalty_amount: Uint128;
}
export interface TokenInfoResponse {
  url: string;
}
export type Cw1155RoyaltiesExecuteMsg = ExecuteMsg;
